import { Record } from 'immutable'

const RollingRuleData = Record({
  columns: undefined,
  rows: undefined,
})

export default RollingRuleData
